import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConverterService,
  OCC_HTTP_TOKEN,
  OccEndpointsService,
  OccProductSearchAdapter,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  ProductSearchPage,
  SearchConfig,
} from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable()
export class ShimanoProductSearchAdapter extends OccProductSearchAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {
    super(http, occEndpoints, converter);
  }

  // Override the search method
  search(query: string, searchConfig: SearchConfig): Observable<ProductSearchPage> {
    const context = new HttpContext().set(OCC_HTTP_TOKEN, {
      sendUserIdAsHeader: true,
    });

    return this.http
      .get(this.getSearchEndpoint(query, searchConfig), { context })
      .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER));
  }
}
